export default __webpack_public_path__ + "0a27eae488e1de256fb946c610f1c9b0.svg";